import { render, staticRenderFns } from "./ReferralHistory.vue?vue&type=template&id=2e5971f7"
import script from "./ReferralHistory.vue?vue&type=script&lang=js"
export * from "./ReferralHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5971f7')) {
      api.createRecord('2e5971f7', component.options)
    } else {
      api.reload('2e5971f7', component.options)
    }
    module.hot.accept("./ReferralHistory.vue?vue&type=template&id=2e5971f7", function () {
      api.rerender('2e5971f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/ReferralHistory.vue"
export default component.exports